module.exports = __webpack_public_path__ + "static/media/queen_of_camelot_italic.cacbef26.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/queen_of_camelot_italic.otf
// module id = 1642
// module chunks = 0